import PageBody from "components/containers/PageBody";
import PageWithHeaderAndFooter from "components/containers/PageWithHeaderAndFooter";
import Page404Content from "pages/errors/Page404Content";

type Props = {
  message?: string;
};

export default function Page404({ message }: Props) {
  return (
    <PageWithHeaderAndFooter>
      <PageBody>
        <Page404Content message={message} />
      </PageBody>
    </PageWithHeaderAndFooter>
  );
}
